<template>
  <v-dialog
    scrollable
    :value="show"
    :max-width="712"
    @click:outside="$emit('close')"
  >
    <v-card class="py-4">
      <v-card-title style="word-break: break-word" class="ma-0 pa-0 mb-4 px-6">
        <p class="ma-0 pa-0 blue-grey--text text--darken-2 h6">
          {{ column.name }}
        </p>
      </v-card-title>
      <v-divider />
      <v-card-text class="ma-0 pa-0 px-6 mt-4" style="max-height: 650px;">
        <Filters readonly :initialFilters="filters" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Filters from '@/components/Filters/Filters.vue'
import _ from 'lodash'

export default {
  name: 'FilterDetailsDialog',

  components: {
    Filters,
  },

  props: {
    show: Boolean,
    column: {
      type: Object,
    },
  },
  computed: {
    filters() {
      const filter = this.column.userFilter?.id
        ? this.column.userFilter?.filters
        : this.column?.filter
      return _.omitBy(
        filter,
        (value, key) =>
          (_.isArray(value) && _.isEmpty(value)) ||
          _.isNull(value) ||
          key === '_id'
      )
    },
  },
}
</script>
<style lang="scss">
.readonly-filter-chip::before {
  background-color: $color-blue-grey-lighten3 !important;
}
</style>
